
const texts = {
  confirmRejectDialog: {
    aceptar: 'Aceptar la acción',
    estasSeguro: '¿Querés rechazar este documento?',
    rechazar: 'Volver atrás sin hacer cambios',
  },
  errorMessages: {
    networkError: 'EF001: Hubo un error de conexión con el servidor. Probá otra vez en unos minutos.',
    errorNoCoincideFirmante: 'EF0022: No podés firmar este documento.El nombre del firmante es distinto al usuario con el que entraste.',
    obtenerEstadoFirma: 'EF0023: No se pudo obtener el estado de la firma.Probá nuevamente en unos minutos.Si sigue el problema, contactá a soporte.',
    rechazarFirma: 'EF0024: No se pudo rechazar la firma del documento.Probá nuevamente en unos minutos.Si sigue el problema, contactá a soporte.',
    noHayUrl: 'EF0025: No se pudo descargar el documento.Probá nuevamente en unos minutos.Si sigue el problema, contactá a soporte.',
    obtenerUrl: 'EF0026: No se puede ingresar a  el documento.Probá nuevamente en unos minutos.',
    cambiarEmail: 'EF0027: No se pudo acceder al documento. Probá de nuevo en unos minutos. Si el problema continúa, contactá a soporte.',
    peticionTardo: 'EF002: El servidor no respondió. Probá de nuevo en unos minutos. Si el problema sigue, escribí a soporte.',
  },
  fechaIn: 'Día en que comienza la firma del documento:',
  fechaFin: 'Último día para firmar el documento:',
  fechaPub: 'Día en que el documento se subió a la plataforma:',
  publicado: 'Publicado por:',
  firmantesTable: {
    title: 'Lista de personas que deben firmar',
    nameFirmante: 'Nombre',
    cuitFirmante: 'CUIL',
    emailFirmante: 'Email',
    tipoFirma: 'Forma en que se realiza la firma',
    estado: 'Estado de la firma',
    cambioEstado: 'Circuito de firma',
    editarEmail: 'Modificar la dirección de correo:',
  },
  qr: 'Usá tu celular para escanear el código QR.',
  documentStatus: {
    rechazo: 'Este documento fue rechazado.',
    vencido: 'Este documento ya pasó la fecha límite para firmarlo.',
    proceso: 'El proceso de firma todavía no terminó.',
    firmado: 'Tu firma está lista y guardada.',
  },
  buttons: {
    denegar: 'Rechazar',
    cancel: 'Cancelar',
    clean: 'Limpiar campos',
    save: 'Guardar cambios',
    confirmar: 'Firmar documento',
    dowload: 'Descargar documento',
  },
};

export default texts;
